<template>
    <mercur-card v-if="isAllowedTo('SupplierCentral/getLocationsBySupplierId')" class="full-height-layout mx-4 mb-3">
        <div class="flex px-4 justify-content-between align-items-center">
            <h2 class="font-weight-normal">Locations</h2>
            <div>
                <mercur-button
                    v-if="isAllowedTo('SupplierCentral/addLocation') && enableLocationSync"
                    @click="triggerLocationsSync"
                    class="btn btn-raised btn-yellow text-uppercase">
                    <i class="fa fa-rotate-right"></i>
                    Sync locations
                </mercur-button>
                <mercur-button
                    v-if="isAllowedTo('SupplierCentral/addLocation')"
                    :to="addOfficeRoute"
                    class="btn btn-raised btn-yellow text-uppercase">
                    <i class="fas fa-plus"></i>
                    Add new office
                </mercur-button>
            </div>
        </div>

        <location-list class="fill" :locations="locations" v-if="locations"></location-list>
        <div v-else-if="locations && locations.length === 0" class="flex align-items-center justify-content-center flex-column">
            <i class="fas fa-search-location no-location-icon"></i>
            <h1>No locations found</h1>
            <h3 class="font-weight-normal mt-0">No locations were found for this supplier</h3>
        </div>

        <div>
            <mercur-dialog :is-open.sync="dialog.isOpen">
                <template slot="header" v-if="dialog.header">
                    <h3>{{dialog.header}}</h3>
                </template>
                <p>{{dialog.content}}</p>
                <template slot="footer">
                    <mercur-button class="btn" @click="dialog.isOpen = false">Cancel</mercur-button>
                    <mercur-button class="btn btn-raised btn-primary" @click="dialog.action">Confirm</mercur-button>
                </template>
            </mercur-dialog>
        </div>
    </mercur-card>
    <div v-else>
        <p class="permission-message">Not allowed to see this view</p>
    </div>
</template>

<script>
import CONFIG from '@root/config'
import LocationList from '@/components/LocationList'

export default {
    name: 'LocationsOverview',
    components: { LocationList },

    data () {
        return {
            url: CONFIG.API.ROUTES.SUPPLIERS.LOCATIONS.replace('{supplierId}', this.supplierId),
            locations: null,
            enableLocationSync: false,
            dialog: {
                isOpen: false,
                action: () => {},
            },
        }
    },

    computed: {
        supplierLocations () {
            return this.$store.getters['suppliers/getLocationsBySupplierId'](this.supplierId)
        },
        addOfficeRoute () {
            return '/supplier/' + this.supplierId + '/locations/add-office'
        },
    },

    watch: {
        supplierLocations (locations) {
            if (!locations) {
                return
            }

            this.locations = JSON.parse(JSON.stringify(locations)).map(location => {
                location.locationStatus = 'ACTIVE'
                return location
            })
        },
    },

    methods: {
        triggerLocationsSync () {
            this.dialog = {
                isOpen: true,
                header: 'Sync locations',
                content: `Are you sure that you want to sync the locations? Note: this action will sync the entire location data and holidays from the parent supplier.`,
                action: () => this.syncLocations(),
            }
        },
        syncLocations () {
            const url = CONFIG.API.ROUTES.SUPPLIERS.SYNC_LOCATIONS.replace('{supplierId}', this.supplierId)
            this.isLoading = true
            this.addJob(url)
            this.$api.post(url, {}).then(({ data }) => {
                this.$store.dispatch('suppliers/fetchSupplierLocations', this.supplierId)

                this.$root.$emit('notification:global', {
                    message: 'Locations and holidays successfully synced',
                })

                this.dialog.isOpen = false
            }).catch(data => {
                this.$root.$emit('notification:global', {
                    message: `Sync failed. Please try again.`,
                    type: 'error',
                    errors: data,
                })
            }).finally(() => {
                this.isLoading = false
                this.finishJob(url)
            })
        },
    },

    created () {
        this.$store.dispatch('suppliers/fetchSupplierLocations', this.supplierId)

        this.supplierData.then(supplierDetails => {
            this.enableLocationSync = supplierDetails.parentSupplierId !== null
        })
    },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables.scss';

.no-location-icon {
    font-size: 7rem;
    color: gray;
}
</style>
